import * as React from 'react';
import { SVGProps } from 'react';

const IconUploadSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 20v2h20v-2H2zm3.41-8.59L4 10l8-8 8 8-1.41 1.41L13 5.83V18h-2V5.83l-5.59 5.58z" />
  </svg>
);
export default IconUploadSizeM;
